import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Alert } from 'antd';
import { ApplicationState } from '../../reducers';
import { getSelectedBrandCode } from '../../selectors/brand/brandSelector';
import { intercomEvent } from '../../utils/IntercomUtils';
import { hasPermission } from '../../utils/Permissions';
import CustomAppsEmbedded from '../../components/body/settings/customApps/CustomAppsEmbedded';
import Page from '../../components/global/page/Page';
import { BRAND_AREA } from '../../constants/InAppAreaConst';

const CustomAppContainer: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { appId } = useParams<{ appId: string }>();

  const user = useSelector((state: ApplicationState) => state.user.user);
  const brandCode = useSelector((state: ApplicationState) => getSelectedBrandCode(state));
  const brandId = useSelector((state: ApplicationState) => state.parent.brands.selectedBrandId);
  const inAppArea = useSelector((state: ApplicationState) => state.app.global.inAppArea);

  const brandView = inAppArea === BRAND_AREA && location.pathname.startsWith('/brand/custom-app');

  const canAccessCustomApps = useMemo(() => hasPermission(user, 'can_access_replit'), [user]);

  React.useEffect(() => {
    intercomEvent('viewed-custom-apps');
  }, []);

  if (!canAccessCustomApps) {
    return (
      <Page>
        <div className="p-5">
          <Alert
            showIcon
            type="info"
            message={t('common:noAccess')}
            description={t('replit:noPermission')}
          />
        </div>
      </Page>
    );
  }

  return (
    <Page>
      <CustomAppsEmbedded
        brandId={brandView ? brandId : undefined}
        brandCode={brandView ? brandCode : undefined}
        appId={Number(appId)}
        hideAppSelector
      />
    </Page>
  );
};

export default CustomAppContainer;
